<template>
  <article class="submit_success">
    <section class="tip-result">
      <i class="result-ico icon-tipico-ok" v-if="query.status"></i>
      <i class="result-ico icon-error" v-if="!query.status"></i>
      <p class="result-hd">{{query.message}}</p>
    </section>
    <section>
      <div class="operate_btn">
        <a v-if="query.retryBtn" href="javascript:void(0);" class="btn blue_btn" @click.stop="handleRetry">再次发起放行</a>
        <a v-if="query.viewProcessBtn" href="javascript:void(0);" class="btn blue_btn" @click.stop="handleProcessView">查看审核进度</a>
        <a href="javascript:void(0);" class="btn" @click.stop="handlerClose">关闭</a>
      </div>
    </section>
  </article>
</template>
<script>
import util from '../../common/util'
export default {
  data() {
    return {
      query: {
        status: true,
        message: '',
        retryBtn: false,
        viewProcessBtn: false
      }
    }
  },
  computed: {
    reviewers() {
      let reviewerList = this.reviewerList || []
      let reviewers = []
      reviewerList.forEach((val) => {
        reviewers.push(val.employee_name)
      })
      return reviewers.join(',')
    },
    isDOS() {
      return this.$store.state.isDOS
    }
  },
  created() {
    this.query = this.$route.query
  },
  mounted () {
    if (!this.query.status) {
      util.changeTitle('撤回失败')
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   this.handlerClose()
  // },
  methods: {
    handlerClose() {
      this.$wechat.promise.then(wx => {
        wx.closeWindow()
      }, wx => {
        throw new Error(`撤回成功页面：埋点错误WeixinJSBridge:${JSON.stringify(wx.res)}`)
      })
    },
    handleRetry() {
      if (this.query.notPlate) {
        this.$router.push('/leaveRegisterNotPlate/index')
        return
      }
      this.$router.push({
        path: `/barriergate/create/${this.query.id}`
      })
    },
    handleProcessView() {
      this.$router.push({
        path: `/barriergate/flow/detail/${this.query.id}/${this.query.process_id}`
      })
    }
  }
}

</script>

<style lang="less" scoped>
@import "../../stylesheets/modules/components/success.less";
</style>
